"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObjectTypeEnum = exports.InlineObjectToJSON = exports.InlineObjectFromJSONTyped = exports.InlineObjectFromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineObjectFromJSON(json) {
    return InlineObjectFromJSONTyped(json, false);
}
exports.InlineObjectFromJSON = InlineObjectFromJSON;
function InlineObjectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'appId': !(0, runtime_1.exists)(json, 'appId') ? undefined : json['appId'],
    };
}
exports.InlineObjectFromJSONTyped = InlineObjectFromJSONTyped;
function InlineObjectToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'appId': value.appId,
    };
}
exports.InlineObjectToJSON = InlineObjectToJSON;
/**
* @export
* @enum {string}
*/
var InlineObjectTypeEnum;
(function (InlineObjectTypeEnum) {
    InlineObjectTypeEnum["All"] = "all";
    InlineObjectTypeEnum["News"] = "news";
    InlineObjectTypeEnum["Game"] = "game";
})(InlineObjectTypeEnum = exports.InlineObjectTypeEnum || (exports.InlineObjectTypeEnum = {}));
